import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const findingTemplatesNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.finding_templates_findings, {
      displayName: 'Findings',
      icon: SolIcon.finding,
      children: [
        SolNavbarItem.of(PrototypeRouteId.finding_templates_vulnerabilities, {
          displayName: 'Vulnerabilities',
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_templates_informational, {
          displayName: 'Informational',
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_templates_compliance, {
          displayName: 'Compliance',
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_templates_list, {
          displayName: 'Finding templates',
        }),
        SolNavbarItem.of(PrototypeRouteId.finding_templates_catalog, {
          displayName: 'Catalog',
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
